import { put, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import JWTDecode from 'jwt-decode';

import api from '../../services/api';
import { formatter } from '../../services/apiResponseFormatter';
import { siteParams } from '../../config/site';

import { Creators as UserCreators } from '../ducks/user';
import { Creators as MessagesCreators } from '../ducks/messages';
import { Creators as SessionCreators } from '../ducks/session';

export function* refrash() {
  const authToken = window.localStorage.getItem('authToken');
  if (!authToken) return;
  yield put(UserCreators.loadUser(JWTDecode(authToken)));
}

export function* updateUser(params) {
  const customer = {
    nickname: params.nickname,
  };
  if (params.email !== '') {
    customer.email = params.email;
  }

  const response = yield call(api.patch, `v2/customers/${params.id}`, {
    customer,
  });

  if (response.ok) {
    yield put(UserCreators.updateSuccess());
    yield put(SessionCreators.saveSession(response.data.token));
    yield put(MessagesCreators.setMessage('Dados do usuário editados com sucesso.', 'success'));
  } else {
    yield put(UserCreators.updateError());
    yield put(MessagesCreators.setMessage('Ocorreu um erro ao editar dados do usuário.', 'warning'));
  }
}

export function* updateUserConfirmation(params) {

  const response = yield call(api.put, `v1/partners/customers/${params.token}`, {
    customer: params,
  });

  if (response.ok) {
    yield put(UserCreators.updateSuccess());
    window.location.href = siteParams.download.url;
  } else {
    yield put(UserCreators.updateError());
    yield put(MessagesCreators.setMessage(formatter(response.data), 'warning'));
  }
}

export function* getUserConfirmation(params) {
  const response = yield call(api.get, 'v1/partners/customers/' + params.token);
  if (response.ok) {
    yield put(UserCreators.getUserConfirmationSuccess(response.data));
  }
}




// WEBPACK FOOTER //
// ./src/store/sagas/user.js